import styled from 'styled-components';

export const Paragraph = styled.p`
  font-size: 0.9rem;
  margin: 0;
`;

export const LabelVehicle = styled.span`
  font-weight: bold;
  margin: 0 0.2rem 0 0;
`;

